import api, { setToken } from '../index';

export function programs(data) {
	return api.get('/courses', setToken(data));
}

export function courseProgram(data) {
	return api.get(`/courses/${data.programId}`, setToken(data.token));
}

export function sendLessonVideo(data) {
	return api.post(`/courses/lesson-video/${data.eventId}/send`, {}, setToken(data.token));
}
